'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NameInput = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseInlineTextField = require('@bibliocommons/base-inline-text-field');

var _baseInlineTextField2 = _interopRequireDefault(_baseInlineTextField);

var _constantsList = require('@bibliocommons/constants-list');

var _nameDropdown = require('../../name-dropdown');

var _nameDropdown2 = _interopRequireDefault(_nameDropdown);

var _restrictedLengthText = require('../../restricted-length-text');

var _restrictedLengthText2 = _interopRequireDefault(_restrictedLengthText);

require('../styles/NameInput.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NameInput = exports.NameInput = function (_BcReactComponent) {
  _inherits(NameInput, _BcReactComponent);

  function NameInput(props) {
    _classCallCheck(this, NameInput);

    var _this = _possibleConstructorReturn(this, (NameInput.__proto__ || Object.getPrototypeOf(NameInput)).call(this, props));

    _this.bindAll('handleChange');
    return _this;
  }

  _createClass(NameInput, [{
    key: 'handleChange',
    value: function handleChange(value) {
      this.props.handleListPropertyChange(_immutable2.default.Map({ name: value }));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          value = _props.value,
          allowFreeText = _props.allowFreeText,
          listNameExamples = _props.listNameExamples,
          handleListPropertyChange = _props.handleListPropertyChange,
          intl = _props.intl;


      if (!allowFreeText) {
        return _react2.default.createElement(
          'div',
          { className: 'cp-name-input' },
          _react2.default.createElement(_nameDropdown2.default, {
            handleListPropertyChange: handleListPropertyChange,
            value: value,
            listNames: listNameExamples })
        );
      }

      return _react2.default.createElement(
        'div',
        { className: 'cp-name-input' },
        _react2.default.createElement(
          'label',
          { className: 'sr-only', id: 'list-name-label', htmlFor: 'list-name' },
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_add_title' })
        ),
        _react2.default.createElement(
          _baseInlineTextField2.default,
          {
            id: 'list-name',
            labelledById: 'list-name-label',
            value: value,
            showRemainingCharacterCount: true,
            suggestedMaxLength: _constantsList.LIST_NAME_LENGTH_SOFT_LIMIT,
            maxLength: 255,
            highlightOnHover: true,
            handleChange: this.handleChange,
            prompt: intl.formatMessage({ id: 'user_list_add_title' }),
            customClass: 'list-title-input',
            buttonTestId: 'edit-list-name-button',
            inputTestId: 'list-name-text-area' },
          _react2.default.createElement(
            'h2',
            { className: 'list-name-value', 'data-test-id': 'list-name-value' },
            _react2.default.createElement(_restrictedLengthText2.default, {
              text: value,
              limit: _constantsList.LIST_NAME_LENGTH_SOFT_LIMIT })
          )
        )
      );
    }
  }]);

  return NameInput;
}(_baseBcReactComponent2.default);

NameInput.propTypes = {
  value: _react.PropTypes.string,
  allowFreeText: _react.PropTypes.bool.isRequired,
  handleListPropertyChange: _react.PropTypes.func,
  listNameExamples: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
  intl: _reactIntl.intlShape
};

exports.default = (0, _reactIntl.injectIntl)(NameInput);


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/name-input/components/NameInput.component.js
// module id = 1325
// module chunks = 0